export const getCurrentSubscription = (subscriptions) => {
  const list = Array.isArray(subscriptions) ? subscriptions : []
  const now = Date.now()

  const activeSubscription = list.find((subscription) => {
    const expirationTime = subscription?.expiration
      ? new Date(subscription.expiration).getTime()
      : 0

    return subscription?.active === true && expirationTime >= now
  })

  return activeSubscription || null
}

export const getCurrentSubscriptionPlanName = (subscriptions) => {
  const currentSubscription = getCurrentSubscription(subscriptions)
  const description = currentSubscription?.Plan?.description || currentSubscription?.plan?.description

  if (!description) {
    return 'Free'
  }

  return description.split(' ')[1] || 'Free'
}
